const defaultOptions = {
  pageSize: 50,
  rowsPerPageOptions: [50, 75, 100],
};

export default defaultOptions;
